<template>
  <div>
    <v-row v-if="isLoading" class="d-flex justify-center">
      <v-progress-circular indeterminate color="primary" size="50">
      </v-progress-circular>
    </v-row>
    <v-row class="doc-container" ref="docContainer">
      <v-col v-for="(d, di) in data" :key="'d' + di" :style="{ 'min-height': containerHeight, 'flex-grow': d.versions?.length || 1 }">
        <v-alert
          v-if="multiDoc && hierarchySuggestions && hierarchySuggestions.show"
          border="top"
          colored-border
          elevation="2"
          class="mb-8"
          ><v-row>
            <v-col
              ><h4>
                AI Generated
                {{ hierarchySuggestions.hierarchyType.ht_name }} Suggestions:
              </h4></v-col
            >
          </v-row>
          <div v-if="d.suggestionProcessed" class="pa-4">
            Document Updated with selected hierarchy <v-icon color="green">mdi-check-circle</v-icon>
          </div>
          <div v-else>
            <v-row v-if="d.suggestions.length" dense>
              <v-col
                v-for="l in hierarchySuggestions.hierarchyType.h_levels"
                :key="l"
                style="text-align: left"
                ><h4>{{ l }}</h4></v-col
              >
              <v-col cols="2"></v-col>
            </v-row>
            <v-row v-else>
              <v-col v-if="isLoadingSuggestions"
                >Identifying
                {{
                  hierarchySuggestions.hierarchyType.h_levels.join(" / ")
                }}s....
                <v-progress-circular indeterminate color="primary" size="30">
                </v-progress-circular
              ></v-col>
              <v-col v-else
                >No relevant
                {{ hierarchySuggestions.hierarchyType.h_levels.join(" / ") }}s
                cound be identified</v-col
              >
            </v-row>
            <v-row dense v-for="(s, si) in d.suggestions" :key="'hs' + si">
              <v-col style="text-align: left; font-size: 12px"
                >{{ s.family_group
                }}<v-icon
                  v-if="!s.original_family_group"
                  color="red"
                  title="New Job Family Group"
                  >mdi-alert-decagram</v-icon
                ></v-col
              >
              <v-col style="text-align: left; font-size: 12px"
                >{{ s.family }}
                <v-icon
                  v-if="!s.original_family"
                  color="red"
                  title="New Job Family"
                  style="padding-left: 15px"
                  >mdi-alert-decagram</v-icon
                ></v-col
              >
              <v-col style="text-align: left; font-size: 12px"
                >{{ s.title
                }}<v-icon
                  v-if="!s.original_title"
                  color="red"
                  title="New Job Title"
                  >mdi-alert-decagram</v-icon
                ></v-col
              >
              <v-col cols="2"
                ><v-btn small @click="assignHierarchy(s, d)"
                  >Assign</v-btn
                ></v-col
              >
            </v-row>
          </div>
        </v-alert>

        <v-row class="doc-header">
          <template v-if="d.doc_id && !d.file_id">
            <v-col v-for="(v, vi) in d.versions" :key="`vh${di}_${vi}`" :class="{ sticky: multiDoc && data.length === 1 && vi === 0 }">
              <v-row dense v-if="multiDoc">
                <v-col>
                  {{ v.doc_name }}
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  <v-icon
                    v-if="showWorkflowActions"
                    @click="openDocActionsMenuContext($event, v)"
                    >mdi-dots-vertical</v-icon
                  >
                </v-col>
                <v-col cols="12">
                  {{ v.reference }}
                  <v-chip
                    small
                    class="status-chip"
                    label
                    :color="v.status_colour"
                    >{{ v.status }}</v-chip
                  >
                  <v-chip 
                    v-if="v.doc_id === currentDocId && d.tmpl_name?.toLowerCase().includes('job')"
                    class="ml-2"
                    small>
                    CURRENT JOB
                  </v-chip>
                  <v-chip 
                    v-if="v.matchPctContent"
                    class="ml-2"
                    small>
                    {{v.matchPctContent + "%"}} match
                  </v-chip>
                  <v-chip 
                    v-else-if="v.matchPctName"
                    class="ml-2"
                    small>
                    {{v.matchPctContent + "%"}} match
                  </v-chip>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col>
                  <v-chip
                    small
                    class="status-chip mr-2"
                    label
                    :color="d.versions[vi].status_colour || d.status_colour"
                    >{{ d.versions[vi].status || d.status }}</v-chip
                  >
                  Updated on {{ d.versions[vi].activity_date }} by
                  {{ d.versions[vi].activity_by }}
                </v-col>
                <v-col cols="1">
                  <v-progress-circular indeterminate size="30" color="primary" v-if="d.versions[vi].exporting">
                  </v-progress-circular>
                  <v-menu v-else offset-y bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="float-right"
                      >
                        <v-icon>download</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="exportVersion(d, vi, 'pdf')" >
                        <v-list-item-title>
                          Export to PDF
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="exportVersion(d, vi, 'docx')" >
                        <v-list-item-title>
                          Export to Word
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <template v-else-if="d.file_id">
            <v-col>
              <v-row dense>
                <v-col>
                  {{ d.doc_name || d.file_name }}
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  <v-btn small icon v-if="d.file_id" title="Download File"
                    @click="openItem(d)"
                    :style="d.reference || d.file_id ? 'cursor: pointer' : ''"
                    ><v-icon>download</v-icon></v-btn
                  >
                </v-col>
                <v-col cols="12">
                  Created {{ d.created_date }} by {{ d.created_by_user || d.created_by }}
                  <v-chip
                    small
                    class="status-chip"
                    label
                    color="blue"
                    >Upload</v-chip
                  >
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
        
        <template v-if="d.doc_id && !d.file_id">
          <template v-for="(tp, tpi) in d.templateParts">

            <v-row v-if="tp.attrs.some(a => a.tag_type_id && a.tag_viewer === 'grid')" class="HeaderPart tag" >
              <v-col :key="`th_${vi}`" v-for="(v, vi) in tp.versions" :class="{ sticky: multiDoc && data.length === 1 && vi === 0 }">
                {{ utils.pluralise(tp.attrs.find(a => a.tag_type_id && a.tag_viewer === 'grid').tag_type_name) }}
              </v-col>
            </v-row>

            <v-row
              v-for="dpi in tp.partsCount"
              :key="`tp${tp.tp_id}_${tpi}_${dpi}`"
              :class="[ tp.partClass, dpi%2 == 1 ? 'odd' : 'even' ]"
            >
              <v-col
                v-for="(v, vi) in tp.versions"
                :key="`v${d.doc_id}_${tpi}_${vi}`"
                :class="{ first: tpi === 0 && dpi === 1, sticky: multiDoc && data.length === 1 && vi === 0 }"
              >
                <DocumentVersionCompareTagSummary 
                  v-if="v[dpi - 1] && v[dpi - 1].tag_value_id"
                  :docPartTag="v[dpi - 1]"
                  :highlightChanges="highlightChanges">
                </DocumentVersionCompareTagSummary>

                <DocumentVersionComparePart
                  v-else-if="v[dpi - 1]"
                  :dp="v[dpi - 1]"
                  :tp="tp"
                  :hideCompareVersion="hideCompareVersion"
                  :highlightChanges="highlightChanges"
                  >
                </DocumentVersionComparePart>
              </v-col>
            </v-row>
          </template>
        </template>
        <v-row v-else-if="d.file_id">
          <v-col style>
            <div v-if="d.contentLoading" class="d-flex justify-center">
              <v-progress-circular indeterminate size="50" color="primary">
              </v-progress-circular>
            </div>
            <span v-else v-html="d.contentHtml"></span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <DocActionsMenu
      :context="docActionsMenuContext"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocActionsMenu>
  </div>
</template>

<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import DocActionsMenu from "@/components/common/DocActionsMenu";
import DocumentVersionComparePart from "@/components/audit/cDocumentVersionComparePart";
import DocumentVersionCompareTagSummary from "@/components/audit/cDocumentVersionCompareTagSummary";
import dayJS from "dayjs";
import utils from "@/common/utils.js";
import documentExport from "@/common/documentExport.js";
import nlpUtils from "@/common/nlpUtils.js";

export default {
  name: "DocumentVersionCompare",
  components: {
    ResponseHandler,
    DocActionsMenu,
    DocumentVersionComparePart,
    DocumentVersionCompareTagSummary,
  },
  props: {
    compareList: { type: Array, required: true },
    highlightChanges: { type: Boolean, default: true },
    hideCompareVersion: { type: Boolean, default: false },
    multiDoc: { type: Boolean, default: false },
    showWorkflowActions: { type: Boolean, default: false },
    hierarchySuggestions: { type: Object },
  },
  data: function () {
    return {
      data: [],
      isLoading: false,
      isLoadingSuggestions: false,
      response: null,
      utils: utils,
      nlpUtils: nlpUtils,
      docActionsMenuContext: {
        show: false,
        busy: false,
        document: null,
        posX: 0,
        posY: 0,
      },
      containerHeight: "100%",
    };
  },
  updated() {},
  mounted() {
    this.getData();
  },
  computed: {
    currentDocId() {
      return this.compareList.find(d => d.isCurrentDoc)?.doc_id;
    }
  },
  watch: {},
  methods: {
    setContainerHeight() {
      let container = this.$refs.docContainer;
      if (container && container.scrollHeight > 0) {
        this.containerHeight = `${container.scrollHeight}px`;
      } else {
        this.containerHeight = "100%";
      }
    },
    async getData(existingSuggestions) {
      const params = {
        compareDocs: this.compareList
          .filter((d) => d.doc_id && !d.file_id)
          .map((d) => {
            return {
              doc_id: d.doc_id,
              activity_id: d.activity_id,
              viewAction: d.viewAction,
            }
          }),
      };
      
      const noViewActionDocs = params.compareDocs.filter(x => !x.viewAction);
      if (noViewActionDocs.length) {
        const docIds = [...new Set(noViewActionDocs.map(d => d.doc_id))];
        await this.$store.getters["docs/getUserViewActions"](docIds)
          .then(vas => vas.forEach(va => {
              params.compareDocs
                .filter(d => d.doc_id == va.doc_id)
                .forEach(d => d.viewAction = va.viewAction);
          }));
      }

      if (params.compareDocs.length === 0) {
        this.data = this.compareList
          .filter((d) => d.file_id)
          .map((d) => {
            const file = {
              ...d,
              contentHtml: null,
              contentLoading: false
            };
            this.fetchFileData(file);
            return file;
          });
        return;
      }

      this.isLoading = true;
      let noPerm = params.compareDocs.filter(x => !x.viewAction).length;
      params.compareDocs = params.compareDocs.filter(x => x.viewAction);
      let shoWarning = false;
      if (!params.compareDocs.length) {        
        this.response = { Status: "warning", message: `You are not permitted to view any of the selected documents.` };
        this.$emit("nodata");
        this.isLoading = false;
        return;
      } else if (noPerm) {
        shoWarning = true;
      }
      axios
        .post("document/documentVersions", params)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            let data = resp.data.Data;
            data.forEach((d) => {
              d.created_date = dayJS(d.created_date).format("DD MMM YYYY");
              if (this.hideCompareVersion && d.versions.length > 1) {
                d.versions.splice(0, 1);
                d.templateParts.forEach((tp) => {
                  tp.versions.splice(0, 1);
                });
              }
              d.versions.forEach(
                (v) => {
                  v.activity_date = dayJS(v.activity_date).format(
                    "DD MMM YYYY HH:mm"
                  );
                  v.exporting = false;
                  v.matchPctContent = this.getMatchPctContent(v);
                  v.matchPctName = this.getMatchPctName(v);
                }
              );
            });
            let dat = [
              ...data,
              ...this.compareList
                .filter((d) => d.file_id)
                .map((d) => {
                  const file = {
                    ...d,
                    contentHtml: null,
                    contentLoading: false
                  };
                  this.fetchFileData(file);
                  return file;
                }),
            ];
            if (this.hideCompareVersion) {
              dat.forEach((d) => {
                let source = this.compareList.find(
                  (x) => x.doc_id === d.doc_id
                );
                if (source) {
                  d.match_pct_content === source.match_pct_content;
                  d.match_pct_name === source.match_pct_name;
                }
              });
            }
            if (this.hierarchySuggestions?.show) {
              dat.forEach((d) => {
                let e = existingSuggestions
                  ? existingSuggestions.find((e) => e.doc_id === d.doc_id)
                  : null;
                d.suggestions = e ? e.suggestions : [];
                d.suggestionProcessed = e ? e.suggestionProcessed : false;
              });
              if (!existingSuggestions) this.getSuggestion();
            }
            this.data = dat;
          } else {
            alert(resp.data.Message);
          }
          if (shoWarning) {
            this.response = { Status: "warning", message: `NOTE: You are not permitted to view ${noPerm} of the selected documents.` };
          } else {
            this.response = resp.data;
          }
          this.isLoading = false;
          setTimeout(() => {
            this.setContainerHeight();
          }, 100);
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    getSuggestion() {
      this.isLoadingSuggestions = true;
      const docs = this.compareList
        .filter((d) => d.doc_id)
        .map((d) => {
          return {
            doc_id: d.doc_id,
            title: d.doc_name,
          };
        });
      axios
        .post("document/hierarchysuggestion", {
          docs: docs,
          ht_id: this.hierarchySuggestions?.hierarchyType.ht_id,
        })
        .then((resp) => {
          if (resp.data.Status === "OK") {
            let data = resp.data.Data;
            if (this.hierarchySuggestions?.show) {
              this.data.forEach(
                (d) =>
                  (d.suggestions =
                    data.docs.find((x) => x.doc_id === d.doc_id)?.suggestions ||
                    [])
              );
            }
          } else {
            alert(resp.data.Message);
          }
          this.response = resp.data;
          this.isLoadingSuggestions = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoadingSuggestions = false;
        });
    },
    fetchFileData(file) {
      file.contentLoading = true;
      nlpUtils.getDocText(file.file_id, file.row_id).then((response) => {
        if (response.status == 200 && (response.data.rawText || response.data.rawData)) {
          let sourceText =
            response.data.rawText?.match(/<[a-z][\s\S]*>/i)?.length > 0
              ? response.data.rawText
              : response.data.rawData;
          file.contentHtml = sourceText
            ?.replaceAll("<em>", "")
            ?.replaceAll("</em>", "");
        } else {
          this.response = response;
        }
        file.contentLoading = false;
        setTimeout(() => {
          this.setContainerHeight();
        }, 100);
      });
    },
    openDocActionsMenuContext(event, document) {
      event.preventDefault();
      let doc = {
        doc_id: document.doc_id,
        reference: document.reference,
        doc_name: document.doc_name,
        doc_type: document.doc_type,
      };
      this.docActionsMenuContext.document = doc;
      this.docActionsMenuContext.posX = event.clientX;
      this.docActionsMenuContext.posY = event.clientY;
      this.docActionsMenuContext.show = false;
      this.$nextTick(() => {
        this.docActionsMenuContext.show = true;
      });
    },
    openItem(item) {
      if (item.reference) this.openDocument(item);
      else if (item.file_id) this.nlpUtils.downloadFile(item.file_id);
    },
    openDocument(item) {
      if (!item.reference) return;

      this.$emit("openDocument", {
        system_number: utils.removeTags(item.reference),
        doc_name: utils.removeTags(item.doc_name),
        doc_type: item.doc_type,
        viewAction: item.viewAction,
      });
    },
    async exportVersion(item, index, format) {
      this.exporting = true;
      const version = item.versions[index]
      version.exporting = true;
      const docIds = [item.doc_id];
      const viewAction =
        (await this.$store.getters["docs/getUserViewActions"](docIds))
        .find(va => va.doc_id == item.doc_id)?.viewAction;

      const params = {
        compareDocs: [
          { doc_id: item.doc_id, activity_id: version.compare_activity_id, viewAction: viewAction },
          { doc_id: item.doc_id, activity_id: version.document_activity_id, viewAction: viewAction }
        ],
        format: format,
        highlightChanges: this.highlightChanges
      };

      axios
        .post("document/documentVersionsExport", params, { responseType: 'arraybuffer' })
        .then((resp) => {   
          const docName = `${item.reference}_${version.status}Version_${dayJS(version.activity_date).format("YYYYMMDDHHmm")}.${format}`;
          utils.downloadFile(resp.data, docName, documentExport.getMimeType(format));
          version.exporting = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = { message: "Unexpected Error" };
          }
          version.exporting = false;
        });
    },
    getMatchPctContent(d) {
      let pct = this.compareList.find(
        (x) => x.doc_id === d.doc_id
      )?.match_pct_content;
      if (pct) return Number.parseFloat(pct).toFixed();
      else return false;
    },
    getMatchPctName(d) {
      let pct = this.compareList.find(
        (x) => x.doc_id === d.doc_id
      )?.match_pct_name;
      if (pct) return Number.parseFloat(pct).toFixed();
      else return false;
    },
    assignHierarchy(selected, d) {
      // transpose service response into something more generic
      let data = {
        ht_id: this.hierarchySuggestions.hierarchyType.ht_id,
        values: [
          {
            level: 1,
            existing: selected.original_family_group,
            name: selected.family_group,
          },
          {
            level: 2,
            existing: selected.original_family,
            name: selected.family,
          },
          { level: 3, existing: selected.original_title, name: selected.title },
        ],
        doc_id: d.doc_id,
        callback: this.assignHierarchyCompleted,
      };
      this.$emit("assignHierarchy", data);
    },
    assignHierarchyCompleted(doc_id) {
      let existing = this.data.find((d) => d.doc_id === doc_id);
      if (existing) existing.suggestionProcessed = true;
      let previous = this.data.map((d) => {
        return {
          doc_id: d.doc_id,
          suggestions: d.suggestions,
          suggestionProcessed: d.suggestionProcessed,
        };
      });
      this.getData(previous);
    },
  },
};
</script>
<style scoped lang="scss">
.doc-container {
  display: flex;
  overflow: auto;
  flex-wrap: nowrap;
  max-height: calc(90vh - 120px) !important;
  border-radius: 10px;
  &::-webkit-scrollbar-track {
    border-radius: 0 10px 10px 0;
  }
  .v-chip {
    border-radius: 4px;
    padding: 0 6px;
  }
  > .col {
    width: auto;
    max-width: unset;
    align-self: stretch;
    > .row {
      flex-wrap: nowrap;
      &.doc-header {
        position: sticky;
        top: 0;
        z-index: 2;
        > .col {
          padding: 15px;
          font-weight: bold;
          > .row > .col {
            min-height: 36px;
          }
        }
      }
      &.HeaderPart > .col,
      &.CentralHeaderPart > .col {
        padding: 25px 30px;
      }
      &.HeaderPart.tag > .col {
        padding: 15px 18px;
      }
      > .col {
        &.sticky {
          position: sticky;
          left: 0;
          z-index: 1;
        }
        &.first {
          padding-top: 30px;
        }
        min-width: 400px;
        width: auto;
        flex-grow: 1;
        padding: 20px 30px 15px 30px;

        @media only screen and (min-width: 960px) {
          min-width: calc((100vw - 101px)/2);
        }

        @media only screen and (min-width: 1400px) {
          min-width: calc((100vw - 102px)/3);
        }

        @media only screen and (min-width: 1900px) {
          min-width: calc((100vw - 103px)/4);
        }

        @media only screen and (min-width: 2500px) {
          min-width: calc((100vw - 104px)/5);
        }
      }
    }
  }
}

$background: #ffffff;
$headerBg: #EEEEEE;
$border: #E5E5E5;
$oddRowBg: #F7F9FB;

.v-application.theme--light {
  .doc-container {
    border: 1px solid $border;
    .v-chip {
      background-color: #fff;
      border: 1px solid #CCCCCC;
    }
    > .col {
      &:not(:last-child) {
        border-right: 1px solid $border;
      }
      > .row {
        background-color: $background;
        &.doc-header > .col {
          background-color: $headerBg;
          border-bottom: 1px solid $border;
        }
        &.even > .col {
          background-color: $oddRowBg;
        }
        &.HeaderPart > .col {
          background-color: $headerBg;
          border-top: 1px solid $border;
          border-bottom: 1px solid $border;
        }
        > .col {
          background-color: $background;
          &:not(:last-child) {
            border-right: 1px solid $border;
          }
        }
      }
    }
    &::-webkit-scrollbar-track {
      background-color: $headerBg;
    }
  }
}

$background: #1E1E1E;
$headerBg: #2e2e2e;
$border: #424242;
$oddRowBg: #222222;

.v-application.theme--dark {
  .doc-container {
    border: 1px solid $border;
    .v-chip {
      background-color: #222222;
      border: 1px solid #606060;
    }
    > .col {
      &:not(:last-child) {
        border-right: 1px solid $border;
      }
      > .row {
        background-color: $background;
        &.doc-header > .col {
          background-color: $headerBg;
          border-bottom: 1px solid $border;
        }
        &.even > .col {
          background-color: $oddRowBg;
        }
        &.HeaderPart > .col {
          background-color: $headerBg;
          border-top: 1px solid $border;
          border-bottom: 1px solid $border;
        }
        > .col {
          background-color: $background;
          &:not(:last-child) {
            border-right: 1px solid $border;
          }
        }
      }
    }
    &::-webkit-scrollbar-track {
      background-color: $headerBg;
    }
  }
}
</style>
